var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default"}},[_c('div',{staticClass:"authenticated"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.address,staticClass:"container view"})],1),_c('Disclaimer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }